import { VCol } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('draggable', {
    staticClass: "row",
    attrs: {
      "group": "widgets",
      "handle": ".handle"
    },
    on: {
      "start": function ($event) {
        _vm.widgetIsBeeingDragged = true;
      },
      "end": function ($event) {
        _vm.widgetIsBeeingDragged = false;
      }
    },
    model: {
      value: _vm.orderedWidgetCols,
      callback: function ($$v) {
        _vm.orderedWidgetCols = $$v;
      },
      expression: "orderedWidgetCols"
    }
  }, _vm._l(_vm.orderedWidgetCols, function (col) {
    return _c(VCol, {
      key: col.id,
      staticStyle: {
        "padding": "0px 10px 15px 10px"
      },
      attrs: {
        "cols": col.cols,
        "sm": col.sm,
        "md": col.md,
        "lg": col.lg,
        "xl": col.xl
      }
    }, [_c('widget', {
      attrs: {
        "widget": col.widget,
        "data-set": _vm.getWidgetData(col.widget.id),
        "is-loading": _vm.loadingWidgetData[col.widget.id] !== false,
        "dashboard-id": _vm.dashboard.id,
        "edit-mode": _vm.editMode,
        "date-range": _vm.dateRange,
        "custom-parameters": _vm.customParameters
      },
      on: {
        "refresh-data": () => _vm.refreshSingleWidgetData(col.widget.id),
        "activate-sub-dashboard": function ($event) {
          return _vm.$emit('activate-sub-dashboard', $event);
        }
      }
    })], 1);
  }), 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };